import { legalHtml } from "./legalHtml";

const PAGES = {
  "/aszf": {
    id: "aszf",
    title: "Általános szerződési feltételek – MENSTAGE",
  },
  "/adatkezelesi-tajekoztato": {
    id: "privacy",
    title: "Adatkezelési tájékoztató – MENSTAGE",
  },
  "/cookie-tajekoztato": {
    id: "cookies",
    title: "Cookie-tájékoztató – MENSTAGE",
  },
};

export function legalPageFromPath(pathname) {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  return PAGES[path] || null;
}

export default function LegalPage({ page }) {
  return (
    <main className="legal-page">
      <article
        className="glass legal-doc"
        dangerouslySetInnerHTML={{ __html: legalHtml[page.id] }}
      />
    </main>
  );
}
